module.exports = __webpack_public_path__ + "static/media/sunbeam-hero-fg.d0bf0d83.png";